import { ref } from "vue";
import { defineStore } from "pinia";
import UserService from "@/core/services/UserService";
import JwtService from "@/core/services/JwtService";
import { UserInfoDto } from "@/core/services/ApiClient";

export const useAuthStore = defineStore("auth", () => {
    const errors = ref({});
    const user = ref<UserInfoDto>(UserService.getUser() || {} as UserInfoDto);
    const token = ref<string>(JwtService.getToken() || '');
    const isAuthenticated = ref(!!JwtService.getToken());
    function setAuth(token: string, authUser: UserInfoDto) {
        isAuthenticated.value = true;
        user.value = authUser;
        errors.value = {};
        if (token) {
            JwtService.saveToken(token);
            UserService.saveUser(user.value);
        }
    }

    function setUserInfo( authUser: UserInfoDto) {
        user.value = authUser;
        UserService.saveUser(user.value);
    }
    function purgeAuth() {
        isAuthenticated.value = false;
        user.value = {} as UserInfoDto;
        errors.value = [];
        JwtService.destroyToken();
        UserService.destroyUser();
    }

    function login(token: string, user: UserInfoDto) {
        setAuth(token, user);
    }

    function logout() {
        purgeAuth();
    }

    return {
        errors,
        user,
        token,
        isAuthenticated,
        login,
        logout,
        setUserInfo
    };
});
